module.exports = __webpack_public_path__ + "static/img/draganddropfile.0af9e1b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/draganddropfile.svg
// module id = xXyZ
// module chunks = 31